import { observable, computed, action, makeObservable } from 'mobx'
import Collection from './Collection'
import ExpenseRowModel from '../Models/ExpenseRowModel'

class ExpenseRowCollection extends Collection {
    constructor() {
        super({
            collection: 'expenseRows',
            modelClass: ExpenseRowModel,
        })
        this.addLookup('rowsByPhaseId', 'manyByKey', {
            key: (t) => t.phaseId,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('rowsByProjectId', 'manyByKey', {
            key: (t) => t.projectId,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('rowsByExpenseId', 'manyByKey', {
            key: (t) => t.expenseId,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('rowsByStatus', 'manyByKey', {
            key: (t) => t.status,
            filter: (t) => !t.deletedAt,
        })
        this.addLookup('leafRows', 'list', {
            filter: (m) => {
                return m.isLeaf
            },
        })
        makeObservable(this)
    }
    get rowsById() {
        return this.modelsById
    }
    get rows() {
        return this.models
    }
    @action.bound
    addRow(data) {
        this.add(data)
    }
    @action.bound
    addRows(data) {
        this.addMany(data)
    }
}

export default new ExpenseRowCollection()
export const ExpenseRowCollectionClass = ExpenseRowCollection
